import styled from "styled-components";

import { theme } from "../../themes/themes";
export const GeneralContainer = styled.div`
  flex-grow: 1;
  background-color: ${({ theme }) => theme.background.light};
  margin-bottom: 10px;
  .MuiTabs-scroller.MuiTabs-fixed {
    margin-left: 1.5rem;
  }
  .MuiPaper-root {
    background-color: ${({ theme }) => theme.background.light};
  }
  .MuiTab-wrapper {
    font-size: 14px;
  }
`;

export const CardsWrapper = styled.div`
  margin-left: 1.5rem;
  width: 96.5%;
  display: grid;
  grid-template-columns: 3fr 1fr;
  grid-gap: 1em;
  user-select: none;
  @media only screen and (min-width: 769px) {
    grid-template-columns: 3fr 1fr;
  }
  @media only screen and (min-width: 491px) and (max-width: 768px) {
    grid-template-columns: 2fr 1fr;
  }
  @media only screen and (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

export const ContentLeft = styled.div``;

export const FilterWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const SearchField = styled.div`
  max-width: 270px;
  width: 100%;
  height: 40px;
  position: relative;
  background: ${({ theme }) => theme.neutral.white};
  border-radius: 5px;
  display: flex;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.neutral.gray[700]};
  svg {
    position: absolute;
    right: 10px;
  }
  input {
    font-size: 12px;
    font-weight: 400;
    border: none;
    outline: none;
    width: 85%;
    box-shadow: none;
  }
  input:focus {
    box-shadow: none;
    outline: none;
    border: none;
  }
  input::placeholder {
    color: ${({ theme }) => theme.neutral.gray[700]};
  }
`;
